import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import PublicHealthInitiativesDetails from '../../subdepartmentdetails/PublicHealthInitiatives'


function PublicHealthInitiatives() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Public Health Initiatives || Health and Human Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Health Human Services"
            title="Public Health Initiatives"
            subtitledown="Department of Health & Human Services"
           />
            <PublicHealthInitiativesDetails/>
        </div>
    </>
  )
}

export default PublicHealthInitiatives